/* Hannah Parraga
 * Spanish flashcards website with cards taken
 * from the 1000 most common words 
 */
import React, { Component } from "react"
import { Link } from 'react-router-dom'


class Home extends Component {
  render() {
    return (
      <center>
        <img id="bkg" src="../bkg1.jpeg" alt="bkg" />
        <div className="cardText">
          <h2>
            Aprender español
        </h2>
          <Link to="/esp/cards">
            <button>
              Tarjetas
          </button>
          </Link>
          <Link to="/esp/game">
            <button>
              Juego
          </button>
          </Link>
          <h2>
            Учить русский
        </h2>
          <Link to="/rus/cards">
            <button>
              Карты
          </button>
          </Link>
          <Link to="/rus/game">
            <button>
              Игра
          </button>
          </Link>
        </div>
      </center>
    );
  }
}

export default Home;

